var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _line, _path19, _path20, _path21, _path22, _path23, _circle, _path24, _path25, _path26, _line2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g, _path57, _path58, _path59, _path60, _g2, _g3, _path61, _path62, _path63, _path64, _polygon, _polygon2, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _circle2, _path73, _path74, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c30e0d3c-7d63-44c3-a844-05f19c6deb9e",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "918.21px",
    height: "702.7px",
    viewBox: "0 0 918.21 702.7",
    enableBackground: "new 0 0 918.21 702.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mobile_apps") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0E4E4",
    d: "M213.11,566.491c12.31,0.809,25.32,5.08,36.52-0.09c2.89-1.33,5.51-3.25,8.51-4.32 c6.89-2.461,14.46-0.07,21.4,2.229c54.332,17.984,110.18,31.014,166.86,38.932c11.68,1.629,23.869,3,35-0.801 c8.141-2.77,15.189-8.119,23.25-11.119c13.18-4.891,27.74-3.07,41.77-2.301c36.748,2.002,73.516-3.598,108-16.449l1.811-0.691 c17.418-6.727,37.066-4.086,52.09,7c5.859,4.299,12.076,8.09,18.58,11.33c21.871,11.029,30.996,37.457,20.59,59.631l-0.24,0.52 c-5.719,12.471-10.49,26.43-21.699,34.35c-10.57,7.471-24.439,7.781-37.381,7.811l-79.43,0.189c-8.24,0-16.58,0-24.58-1.939 c-7.189-1.77-13.879-5.09-20.51-8.391l-35.539-17.629c-14.311-7.111-30-14.43-45.66-11.16c-16,3.34-27.531,16.789-41.47,25.27 c-21.631,13.17-50.391,13.689-72.48,1.291c-10.58-5.941-19.77-14.602-31.31-18.33c-19.061-6.17-39.311,2.369-58.92,6.459 c-38.16,7.961-83.11-2.93-112.35-29.26C128.26,605.1,172.48,563.831,213.11,566.491z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M68.8,623.129c0,0-29.11-98.779,5.46-171.559 c14.51-30.531,19.33-64.801,12.62-97.931c-3.204-15.725-7.844-31.123-13.86-46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M94.52,261.71c0,12.11-21.93,47.23-21.93,47.23s-21.93-35.12-21.93-47.23 c-0.002-12.111,9.814-21.932,21.926-21.934c12.111-0.002,21.932,9.814,21.934,21.926C94.52,261.705,94.52,261.708,94.52,261.71 L94.52,261.71z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M130.77,328.8c-6.58,10.17-44.08,27.73-44.08,27.73s0.68-41.4,7.26-51.57 c6.583-10.167,20.162-13.073,30.33-6.49C134.448,305.053,137.353,318.632,130.77,328.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M129.19,443.44c-10.81,5.449-52,1.689-52,1.689s21.49-35.398,32.3-40.85 c10.769-5.543,23.992-1.307,29.535,9.463c5.543,10.768,1.307,23.992-9.462,29.535c-0.107,0.055-0.215,0.109-0.323,0.162H129.19z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M108.46,529.92c-9.74,7.199-51,10.459-51,10.459s15.2-38.52,24.93-45.719 c9.821-7.088,23.528-4.871,30.616,4.949c6.97,9.658,4.956,23.115-4.536,30.311H108.46z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M40.65,358.87c8.69,8.44,49.16,17.18,49.16,17.18s-9.91-40.199-18.6-48.639 c-8.732-8.393-22.615-8.117-31.007,0.616C31.874,336.692,32.073,350.449,40.65,358.87z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M17.68,460.35c10.81,5.449,52,1.689,52,1.689s-21.49-35.4-32.3-40.85 c-10.994-5.082-24.026-0.289-29.108,10.705C3.426,442.377,7.541,454.821,17.68,460.35z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M8.89,561.969c9.74,7.201,51,10.461,51,10.461s-15.2-38.52-24.93-45.721 c-9.821-7.088-23.528-4.871-30.616,4.951c-6.97,9.658-4.956,23.115,4.536,30.309H8.89z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M94.52,261.71c0,12.11-21.93,47.23-21.93,47.23s-21.93-35.12-21.93-47.23 c-0.002-12.111,9.814-21.932,21.926-21.934c12.111-0.002,21.932,9.814,21.934,21.926C94.52,261.705,94.52,261.708,94.52,261.71 L94.52,261.71z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M130.77,328.8c-6.58,10.17-44.08,27.73-44.08,27.73s0.68-41.4,7.26-51.57 c6.583-10.167,20.162-13.073,30.33-6.49C134.448,305.053,137.353,318.632,130.77,328.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M129.19,443.44c-10.81,5.449-52,1.689-52,1.689s21.49-35.398,32.3-40.85 c10.769-5.543,23.992-1.307,29.535,9.463c5.543,10.768,1.307,23.992-9.462,29.535c-0.107,0.055-0.215,0.109-0.323,0.162H129.19z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M108.46,529.92c-9.74,7.199-51,10.459-51,10.459s15.2-38.52,24.93-45.719 c9.821-7.088,23.528-4.871,30.616,4.949c6.97,9.658,4.956,23.115-4.536,30.311H108.46z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M40.65,358.87c8.69,8.44,49.16,17.18,49.16,17.18s-9.91-40.199-18.6-48.639 c-8.732-8.393-22.615-8.117-31.007,0.616C31.874,336.692,32.073,350.449,40.65,358.87z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M17.68,460.35c10.81,5.449,52,1.689,52,1.689s-21.49-35.4-32.3-40.85 c-10.994-5.082-24.026-0.289-29.108,10.705C3.426,442.377,7.541,454.821,17.68,460.35z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M8.89,561.969c9.74,7.201,51,10.461,51,10.461s-15.2-38.52-24.93-45.721 c-9.821-7.088-23.528-4.871-30.616,4.951c-6.97,9.658-4.956,23.115,4.536,30.309H8.89z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1360EF",
    d: "M599.519,349.27c-3.699-29,7.891-58.85,1-87.24c-5.299-21.93-21-40.24-26.158-62.21 c-7.58-32.56,9.76-66,31.889-91c15.221-17.23,34.32-32.87,57.09-36c14.061-2,28.51,1.09,41.49,6.82 c26.684,11.963,47.188,34.485,56.6,62.17c3,8.9,4.73,18.21,8.42,26.84c6.352,14.87,18,26.87,25.25,41.33 c9.771,19.806,10.736,42.814,2.66,63.37c-8.389,20.94-26,38.46-28.6,60.87c-1.891,16.15,4.17,33.84-3.699,48.07 c-5.941,10.74-18.17,16.16-29.75,20.221c-26.941,9.4-64.6,24.6-91.6,10.129C620.49,399.991,602.941,376.04,599.519,349.27z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#333333",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M675.111,369.879c0,0,39.658-16,44.658-25 c5-9,12-62,12-62"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#333333",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 674.73,
    y1: 614.901,
    x2: 674.73,
    y2: 269.9
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 473.0464,
    y1: -59.0327,
    x2: 757.575,
    y2: 612.8201,
    gradientTransform: "matrix(1 -0.0024 -0.0024 -1 -152.6927 603.386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M627.4,0L294.9,0.81c-7.544,0.017-13.646,6.146-13.63,13.69l0,0l1.51,621.85 c0.016,7.545,6.146,13.646,13.689,13.631c0.003,0,0.007,0,0.01,0l332.5-0.811c7.545-0.018,13.646-6.146,13.631-13.689l0,0 l-1.5-621.851C641.093,6.086,634.964-0.017,627.419,0C627.414,0,627.406,0,627.4,0z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#535461",
    d: "M299.763,9.281l322.831-0.789c7.533-0.019,13.654,6.073,13.672,13.606l1.479,604.671 c0.018,7.533-6.074,13.654-13.607,13.672l-322.829,0.789c-7.533,0.02-13.655-6.072-13.673-13.605l-1.478-604.671 C286.138,15.421,292.229,9.3,299.763,9.281z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M628.91,611.29c0.018,7.342-5.918,13.309-13.26,13.33l-306,0.74c-7.342,0.018-13.309-5.918-13.331-13.26 l-0.21-89.75l-1.17-483.92c-0.017-7.341,5.918-13.308,13.26-13.33l64-0.15c2.128,13.826,14.011,24.041,28,24.07l120.92-0.29 c14.029-0.049,25.92-10.334,27.99-24.21l65-0.16c7.34-0.017,13.307,5.918,13.33,13.26l1.25,484.73L628.91,611.29z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M628.91,611.29c0.018,7.342-5.918,13.309-13.26,13.33l-306,0.74c-7.342,0.018-13.309-5.918-13.331-13.26 l-0.21-89.75h332.581L628.91,611.29z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M421.022,32.891l74.012-1.111c1.104-0.017,2.012,0.865,2.029,1.97l0.014,0.88 c0.016,1.104-0.865,2.013-1.971,2.03l-74.011,1.111c-1.104,0.016-2.014-0.866-2.03-1.97l-0.013-0.88 C419.036,33.816,419.918,32.907,421.022,32.891z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 513.629,
    cy: 33.441,
    r: 2.93
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M714.519,349.27c-3.699-29,7.891-58.85,1-87.24c-5.299-21.93-21-40.24-26.158-62.21 c-7.58-32.56,9.76-66,31.889-91c15.221-17.23,34.32-32.87,57.09-36c14.061-2,28.51,1.09,41.49,6.82 c26.684,11.963,47.188,34.485,56.6,62.17c3,8.9,4.73,18.21,8.42,26.84c6.352,14.87,18,26.87,25.25,41.33 c9.773,19.822,10.729,42.847,2.631,63.41c-8.391,20.94-26,38.46-28.6,60.87c-1.891,16.15,4.17,33.84-3.701,48.07 c-5.939,10.739-18.17,16.16-29.75,20.219c-26.91,9.361-64.568,24.561-91.568,10.09C735.49,399.991,717.941,376.04,714.519,349.27z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M714.519,349.27c-3.699-29,7.891-58.85,1-87.24 c-5.299-21.93-21-40.24-26.158-62.21c-7.58-32.56,9.76-66,31.889-91c15.221-17.23,34.32-32.87,57.09-36 c14.061-2,28.51,1.09,41.49,6.82c26.684,11.963,47.188,34.485,56.6,62.17c3,8.9,4.73,18.21,8.42,26.84 c6.352,14.87,18,26.87,25.25,41.33c9.773,19.822,10.729,42.847,2.631,63.41c-8.391,20.94-26,38.46-28.6,60.87 c-1.891,16.15,4.17,33.84-3.701,48.07c-5.939,10.739-18.17,16.16-29.75,20.219c-26.91,9.361-64.568,24.561-91.568,10.09 C735.49,399.991,717.941,376.04,714.519,349.27z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#333333",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M790.111,369.879c0,0,39.658-16,44.658-25 c5-9,12-62,12-62"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#333333",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 789.73,
    y1: 614.901,
    x2: 789.73,
    y2: 269.9
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M141.45,663.35c0,0-12.72-43.189,2.38-75 c6.421-13.291,8.358-28.305,5.52-42.791c-1.402-6.867-3.431-13.592-6.06-20.09"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M152.69,505.411c0,5.289-9.58,20.639-9.58,20.639s-9.58-15.35-9.58-20.639c0-5.295,4.292-9.586,9.585-9.586 c5.293,0,9.585,4.291,9.585,9.586H152.69z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M168.54,534.731c-2.88,4.439-19.26,12.119-19.26,12.119s0.3-18.09,3.17-22.541 c2.877-4.441,8.812-5.711,13.255-2.834C170.148,524.352,171.417,530.288,168.54,534.731L168.54,534.731z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M167.84,584.831c-4.73,2.379-22.75,0.74-22.75,0.74s9.39-15.471,14.12-17.852 c4.725-2.383,10.487-0.484,12.87,4.24C174.463,576.684,172.565,582.448,167.84,584.831z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M158.78,622.62c-4.26,3.15-22.29,4.57-22.29,4.57s6.64-16.83,10.9-20c4.255-3.148,10.257-2.25,13.405,2.006 c3.148,4.254,2.25,10.256-2.005,13.404L158.78,622.62z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M129.11,547.879c3.8,3.691,21.48,7.51,21.48,7.51s-4.33-17.568-8.13-21.26 c-3.797-3.686-9.863-3.596-13.55,0.201S125.313,544.194,129.11,547.879z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M119.11,592.2c4.73,2.381,22.75,0.74,22.75,0.74s-9.39-15.471-14.12-17.85 c-4.725-2.383-10.487-0.484-12.87,4.24C112.487,584.055,114.385,589.817,119.11,592.2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M115.27,636.629c4.26,3.15,22.29,4.57,22.29,4.57s-6.64-16.83-10.9-20 c-4.255-3.148-10.257-2.25-13.405,2.006c-3.148,4.254-2.25,10.256,2.005,13.404L115.27,636.629z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    enableBackground: "new    ",
    d: "M152.69,505.411c0,5.289-9.58,20.639-9.58,20.639s-9.58-15.35-9.58-20.639 c0-5.295,4.292-9.586,9.585-9.586c5.293,0,9.585,4.291,9.585,9.586H152.69z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    enableBackground: "new    ",
    d: "M168.54,534.731c-2.88,4.439-19.26,12.119-19.26,12.119s0.3-18.09,3.17-22.541 c2.877-4.441,8.812-5.711,13.255-2.834C170.148,524.352,171.417,530.288,168.54,534.731L168.54,534.731z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    enableBackground: "new    ",
    d: "M167.84,584.831c-4.73,2.379-22.75,0.74-22.75,0.74s9.39-15.471,14.12-17.852 c4.725-2.383,10.487-0.484,12.87,4.24C174.463,576.684,172.565,582.448,167.84,584.831z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    enableBackground: "new    ",
    d: "M158.78,622.62c-4.26,3.15-22.29,4.57-22.29,4.57s6.64-16.83,10.9-20 c4.255-3.148,10.257-2.25,13.405,2.006c3.148,4.254,2.25,10.256-2.005,13.404L158.78,622.62z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    enableBackground: "new    ",
    d: "M129.11,547.879c3.8,3.691,21.48,7.51,21.48,7.51s-4.33-17.568-8.13-21.26 c-3.797-3.686-9.863-3.596-13.55,0.201S125.313,544.194,129.11,547.879z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    enableBackground: "new    ",
    d: "M119.11,592.2c4.73,2.381,22.75,0.74,22.75,0.74s-9.39-15.471-14.12-17.85 c-4.725-2.383-10.487-0.484-12.87,4.24C112.487,584.055,114.385,589.817,119.11,592.2z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    enableBackground: "new    ",
    d: "M115.27,636.629c4.26,3.15,22.29,4.57,22.29,4.57s-6.64-16.83-10.9-20 c-4.255-3.148-10.257-2.25-13.405,2.006c-3.148,4.254-2.25,10.256,2.005,13.404L115.27,636.629z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M846.169,638.911c0,0-15.76-53.5,3-92.881 c7.949-16.463,10.346-35.059,6.83-53c-1.738-8.506-4.252-16.834-7.51-24.879"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M860.111,443.231c0,6.559-11.871,25.568-11.871,25.568s-11.869-19-11.869-25.568 c0-6.559,5.316-11.875,11.875-11.875s11.875,5.316,11.875,11.875H860.111z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M879.72,479.549c-3.561,5.5-23.859,15-23.859,15s0.369-22.41,3.93-27.92 c3.564-5.502,10.916-7.074,16.42-3.51s7.074,10.916,3.51,16.42l0,0V479.549z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M878.871,541.62c-5.852,3-28.18,0.91-28.18,0.91s11.629-19.16,17.488-22.119 c5.855-2.953,12.994-0.6,15.945,5.254c2.953,5.855,0.6,12.994-5.254,15.945V541.62z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M867.64,588.44c-5.27,3.9-27.621,5.66-27.621,5.66s8.23-20.85,13.5-24.75 c5.273-3.898,12.707-2.787,16.605,2.484C874.025,577.106,872.912,584.542,867.64,588.44z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M830.929,495.84c4.701,4.57,26.621,9.299,26.621,9.299s-5.371-21.77-10.07-26.33 c-4.854-4.406-12.361-4.043-16.768,0.811c-4.189,4.617-4.096,11.688,0.217,16.189V495.84z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M818.5,550.76c5.85,3,28.18,0.91,28.18,0.91s-11.629-19.16-17.488-22.121 c-5.855-2.951-12.994-0.598-15.945,5.256c-2.953,5.854-0.6,12.992,5.254,15.945V550.76z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M813.74,605.79c5.27,3.9,27.621,5.66,27.621,5.66s-8.23-20.85-13.5-24.75 c-5.271-3.898-12.707-2.787-16.605,2.484C807.355,594.458,808.468,601.891,813.74,605.79z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M860.111,443.231c0,6.559-11.871,25.568-11.871,25.568 s-11.869-19-11.869-25.568c0-6.559,5.316-11.875,11.875-11.875s11.875,5.316,11.875,11.875H860.111z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M879.72,479.549c-3.561,5.5-23.859,15-23.859,15 s0.369-22.41,3.93-27.92c3.564-5.502,10.916-7.074,16.42-3.51s7.074,10.916,3.51,16.42l0,0V479.549z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M878.871,541.62c-5.852,3-28.18,0.91-28.18,0.91 s11.629-19.16,17.488-22.119c5.855-2.953,12.994-0.6,15.945,5.254c2.953,5.855,0.6,12.994-5.254,15.945V541.62z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M867.64,588.44c-5.27,3.9-27.621,5.66-27.621,5.66 s8.23-20.85,13.5-24.75c5.273-3.898,12.707-2.787,16.605,2.484C874.025,577.106,872.912,584.542,867.64,588.44z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M830.929,495.84c4.701,4.57,26.621,9.299,26.621,9.299 s-5.371-21.77-10.07-26.33c-4.854-4.406-12.361-4.043-16.768,0.811c-4.189,4.617-4.096,11.688,0.217,16.189V495.84z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M818.5,550.76c5.85,3,28.18,0.91,28.18,0.91 s-11.629-19.16-17.488-22.121c-5.855-2.951-12.994-0.598-15.945,5.256c-2.953,5.854-0.6,12.992,5.254,15.945V550.76z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#F94F15",
    enableBackground: "new    ",
    d: "M813.74,605.79c5.27,3.9,27.621,5.66,27.621,5.66 s-8.23-20.85-13.5-24.75c-5.271-3.898-12.707-2.787-16.605,2.484C807.355,594.458,808.468,601.891,813.74,605.79z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M322.59,101.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.799,0-10.5-4.701-10.5-10.5v-43C312.09,106.561,316.791,101.86,322.59,101.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M401.59,101.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.799,0-10.5-4.701-10.5-10.5v-43C391.09,106.561,395.791,101.86,401.59,101.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M480.589,101.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.799,0-10.5-4.701-10.5-10.5v-43C470.089,106.561,474.791,101.86,480.589,101.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M559.589,101.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.799,0-10.5-4.701-10.5-10.5v-43C549.089,106.561,553.791,101.86,559.589,101.86z"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#1360EF",
    d: "M322.26,197.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.799,0-10.5-4.701-10.5-10.5v-43C311.76,202.561,316.461,197.86,322.26,197.86z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#6C63FF",
    enableBackground: "new    ",
    d: "M401.26,197.86h43c5.799,0,10.5,4.701,10.5,10.5v43 c0,5.799-4.701,10.5-10.5,10.5h-43c-5.799,0-10.5-4.701-10.5-10.5v-43C390.76,202.561,395.461,197.86,401.26,197.86z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#6C63FF",
    enableBackground: "new    ",
    d: "M480.259,197.86h43c5.799,0,10.5,4.701,10.5,10.5v43 c0,5.799-4.701,10.5-10.5,10.5h-43c-5.799,0-10.5-4.701-10.5-10.5v-43C469.759,202.561,474.46,197.86,480.259,197.86z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#6C63FF",
    enableBackground: "new    ",
    d: "M559.259,197.86h43c5.799,0,10.5,4.701,10.5,10.5v43 c0,5.799-4.701,10.5-10.5,10.5h-43c-5.799,0-10.5-4.701-10.5-10.5v-43C548.759,202.561,553.46,197.86,559.259,197.86z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M321.93,293.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.799,0-10.5-4.701-10.5-10.5v-43C311.43,298.561,316.131,293.86,321.93,293.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M400.93,293.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.799,0-10.5-4.701-10.5-10.5v-43C390.43,298.561,395.131,293.86,400.93,293.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M479.929,293.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.799,0-10.5-4.701-10.5-10.5v-43C469.429,298.561,474.13,293.86,479.929,293.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M558.929,293.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.799,0-10.5-4.701-10.5-10.5v-43C548.429,298.561,553.13,293.86,558.929,293.86z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M321.61,389.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.8,0-10.5-4.701-10.5-10.5v-43C311.11,394.561,315.811,389.86,321.61,389.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M400.61,389.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.8,0-10.5-4.701-10.5-10.5v-43C390.11,394.561,394.811,389.86,400.61,389.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M479.611,389.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.801,0-10.5-4.701-10.5-10.5v-43C469.111,394.561,473.81,389.86,479.611,389.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M558.611,389.86h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.801,0-10.5-4.701-10.5-10.5v-43C548.111,394.561,552.81,389.86,558.611,389.86z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1023.3423,
    y1: 329.0596,
    x2: 1023.3423,
    y2: 401.5078,
    gradientTransform: "matrix(-1 0 0 -1 1368.3193 605.0498)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M345.11,270.21v5.78l-24.38-15.4l2.569-3.21l1.19,0.7l18.87-27.65v-16.08l7.189,0.64v-2.57 c19-21.82,20.91,2.57,17,9.63c-3.91,7.06-11.109,12.19-11.109,12.19c-4,3.36-11,28.76-12.69,35.13L345.11,270.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1116.2163,
    y1: -97.6504,
    x2: 1116.2163,
    y2: 444.8848,
    gradientTransform: "matrix(-1 0 0 -1 1368.3193 605.0498)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M160.26,320.6L160.26,320.6c0,0,18.61,36.41,12.83,72.82c-1.94,12.24-1.13,19.719,0.81,24.279 c-0.535,4.93-1.886,9.734-4,14.221c-7.06,14.76-7.06,30.16,1.92,48.129l2.57,93c0,0,3.21,43.631,0,52.621s1.28,52,1.28,52h-0.64 v23.74l48.08,1.289c0,0,11.27-5.35,13.27-9.35l24.16,7.43c0,0,26.59-4.58,11-10.92c-11.61-4.721-14.49-11.471-15.21-14.59l38-109.26 c0,0-7.06-93-32.73-125.131l-2.6-18.92h0.36l5.45-110.47l0.45,0.06h-0.13c14.051,2.246,28.385,2.025,42.36-0.65 c4.19-0.745,8.3-1.894,12.27-3.43l0.73-0.29h0.08h0.069l0,0c2.975-1.219,5.778-2.819,8.341-4.76l16-24.51l-24.381-16.8l-8.34,11.9 c0,0-26.13-5.52-40.48-11.34c-6.68-2.728-13.789-4.254-21-4.51l-15.67-0.54l-7.81-4.69l2.44-6.31c0.24-0.11,0.48-0.22,0.72-0.35 l0.22-1.35c20.056-4.98,32.281-25.272,27.31-45.33h0.51c-0.22-13-4.2-14.27-4.2-14.27c0-13.22-11.55-22.89-24.71-24 c-6.814-0.469-13.661,0.131-20.29,1.78c-9.747,2.327-16.962,10.553-18,20.52c-17.19,4.73-11.43,13.73-11.7,17.18 c-1.32,16.8,4,26.73,9.9,32.52c2.498,2.609,5.432,4.761,8.67,6.36l-3.75,7.51h-1.1l-3.06,9h-0.15l-3.34,2.16 C166.162,271.302,155.759,296.124,160.26,320.6z M211.59,677.67v-28.871l12.19-85.34v-43.639l21.83,45.529l-23.5,98.76l-1.23-0.34 l-5.41,19.439c-1.764-1.465-3.101-3.379-3.87-5.539H211.59z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDA57D",
    d: "M340.22,222.88v15.41l-18.359,26.9l18.359,11.95c0,0,8.16-31.44,12.561-35.14c0,0,6.91-4.93,10.67-11.71 c3.76-6.78,1.88-30.21-16.33-9.25v2.47L340.22,222.88z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDA57D",
    d: "M194.04,259.64l7.27-14.54c0.432-0.87,1.3-1.44,2.27-1.49l27.61-1.41c1.483-0.079,2.75,1.06,2.829,2.543 c0.02,0.38-0.041,0.761-0.179,1.116l-7.12,18.41c-0.432,1.12-1.554,1.817-2.75,1.71l-27.75-2.47 c-1.48-0.128-2.576-1.432-2.447-2.912C193.801,260.265,193.892,259.94,194.04,259.64z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EDEEF9",
    points: "196.08,253.4 191.39,267.15 239.55,265.42 221.05,254.32 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EDEEF9",
    points: "318.47,267.27 320.93,264.19 341.89,276.52 341.89,282.07 "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#7A7478",
    d: "M176.83,403.67c1.934,9.514,0.796,19.395-3.25,28.219c-6.78,14.182-6.78,29,1.85,46.24l2.47,89.4 c0,0,3.08,41.93,0,50.561c-3.08,8.629,1.21,49.949,1.21,49.949h34.53v-27.75l11.71-82V516.35l21,43.779l-24,101.121l31.44,12.949 l39.46-113.449c0,0-6.84-89.4-31.5-120.221l-4.64-33.609L176.83,403.67z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M178.51,690.85V668.04h35.14c0,0,2.47,9.25,18.5,11.1c16.03,1.852-7.4,12.951-7.4,12.951L178.51,690.85z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M216.47,676.651l6.12-22l33.86,9.43c0,0-0.11,9.57,14.84,15.65c14.95,6.078-10.6,10.488-10.6,10.488 L216.47,676.651z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M257.11,408.77l-80.29-3.25c0.995,4.787,1.201,9.705,0.61,14.561 c3.67,8.639,11.55,6.279,11.55,6.279l70.25-2.16L257.11,408.77z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D8AF0",
    d: "M193,262.03l-3.2,2.17c-19.787,13.402-29.78,37.233-25.47,60.74l0,0c0,0,17.88,35,12.33,70 c-5.55,35,12.33,29.6,12.33,29.6l70.6-2.17l5.24-106.149c0,0,42.54,6.05,61.66-8.75l15.41-23.55l-23.431-16.17l-8,11.44 c0,0-25.11-5.3-38.9-10.9c-6.432-2.624-13.277-4.09-20.22-4.33L193,262.03z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M193.62,432.821c0,0-4.32,21.58,20.35,57.34"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M265.11,316.29c0,0,29.59-9.86,42.541-9.86c12.949,0,10.79,5.59,10.79,5.59 S297.82,321.22,265.11,316.29z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M231.58,243.45l-11.78,1.41c-0.37,0-0.71,0.51-0.91,1.24 c2.59,4.67,5.83,7.45,9.35,7.45c1.256-0.019,2.486-0.363,3.57-1l0.9-5.45C233.01,245.29,232.41,243.35,231.58,243.45z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FDA57D",
    cx: 223.36,
    cy: 216.35,
    r: 35.96
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    enableBackground: "new    ",
    d: "M253.95,195.99L253.95,195.99l-1.84,1.66c-2.534,2.32-2.707,6.254-0.387,8.788 c0.611,0.667,1.361,1.194,2.197,1.542l0,0c0,0-16.11,16.11-18.35,19.1c-2.24,2.99,0.37,10.86,0.37,10.86s7.12,13.11-30.34,10.11 c0,0-24.72-5.24-22.1-38.58c0.26-3.34-5.24-12,11.24-16.48l0,0c1.012-9.592,7.98-17.495,17.37-19.7 c6.371-1.584,12.951-2.162,19.5-1.71C244.261,172.69,253.962,183.291,253.95,195.99z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#72351C",
    d: "M254.73,194.03L254.73,194.03c0,0,3.82,1.18,4,13.71l-5.43-0.37c0,0-12.56,33.6-11.24,29.22 c4.87-16.11-4.87-13.11-7.12-10.11s0.37,10.86,0.37,10.86s7.12,13.11-30.34,10.11c0,0-24.72-5.24-22.1-38.58 c0.26-3.34-5.24-12,11.24-16.48l0,0c1.004-9.587,7.959-17.492,17.34-19.71c6.371-1.584,12.95-2.161,19.5-1.71 C243.63,172.04,254.73,181.35,254.73,194.03z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M322.61,542.35h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.8,0-10.5-4.701-10.5-10.5v-43C312.11,547.051,316.811,542.35,322.61,542.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M401.61,542.35h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.8,0-10.5-4.701-10.5-10.5v-43C391.11,547.051,395.811,542.35,401.61,542.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M480.611,542.35h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.801,0-10.5-4.701-10.5-10.5v-43C470.111,547.051,474.81,542.35,480.611,542.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C63FF",
    d: "M559.611,542.35h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43 c-5.801,0-10.5-4.701-10.5-10.5v-43C549.111,547.051,553.81,542.35,559.611,542.35z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.61,542.35h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43c-5.8,0-10.5-4.701-10.5-10.5v-43 C312.11,547.051,316.811,542.35,322.61,542.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.61,542.35h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43c-5.8,0-10.5-4.701-10.5-10.5v-43 C391.11,547.051,395.811,542.35,401.61,542.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.611,542.35h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43c-5.801,0-10.5-4.701-10.5-10.5v-43 C470.111,547.051,474.81,542.35,480.611,542.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.611,542.35h43c5.799,0,10.5,4.701,10.5,10.5v43c0,5.799-4.701,10.5-10.5,10.5h-43c-5.801,0-10.5-4.701-10.5-10.5v-43 C549.111,547.051,553.81,542.35,559.611,542.35z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg08);
export default __webpack_public_path__ + "static/media/08.63bebbd226b87b2fa9d3157d40f5bac9.svg";
export { ForwardRef as ReactComponent };